import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  spacious?: boolean;
}

const PromoBanner = ({ spacious, children }: PropsWithChildren<Props>) => (
  <Box
    sx={(t) => ({
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      rowGap: spacious ? 3 : 2,
      columnGap: spacious ? 4 : 3,
      px: spacious ? 4.5 : 3.25,
      py: spacious ? 5 : 3.5,
      border: 1,
      borderColor: "divider",
      borderRadius: 4,
      background: `radial-gradient(120% 140% at 0% 0%, ${t.alpha(t.palette.primary.light, 0.14)} 0%, transparent 55%), linear-gradient(135deg, ${t.alpha(t.palette.primary.light, 0.07)} 0%, ${t.palette.background.paper} 48%, ${t.palette.background.grey} 100%)`,
    })}
  >
    {children}
  </Box>
);

export default PromoBanner;
